<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: SyncModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="video-modal modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ selectedLabVideoTitle }}</h5>
          <button
            type="button"
            class="video-modal__close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <video ref="video" :tag="modalVideoLink" controls>
            <source ref="source" :src="modalVideoLink" type="video/mp4" />
          </video>
        </div>
        <!-- <div class="modal-footer"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoModal',
  props: {
    videoLink: { type: String, default: '' },
    selectedLabVideoTitle: { type: String, default: 'Video' },
  },
  data() {
    return {
      modalVideoLink: '',
    }
  },
  methods: {},
  mounted() {
    this.$refs.source.addEventListener('error', () => {
      console.error(`Error loading: ${this.modalVideoLink}`)
      this.modalVideoLink = ''
    })
    this.$refs.video.addEventListener('canplaythrough', () => {
      this.$refs.video.play()
    })
  },
  watch: {
    videoLink: {
      handler: async function() {
        console.log(this.videoLink)
        console.log(this.$refs.video)
        this.modalVideoLink = ''
        await this.$refs.video.load()
        this.modalVideoLink = this.videoLink
        await this.$refs.video.load()
      },
    },
  },
  // directives: {
  //   reload(el, binding) {
  //     if (binding.oldValue !== binding.value) {
  //       console.log(el, binding)
  //       el.load()
  //     }
  //   },
  // },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~@/styles/globals';
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
.video-modal {
  .modal-dialog {
    max-width: 770px;
    width: 100%;
    @include media-breakpoint-down(sm) {
      width: 96%;
    }
    .modal-content {
      line-height: 0;
      overflow: hidden;
      .modal-body {
        padding: 0;
        background-color: black;
        video {
          width: 100%;
        }
      }
    }
  }
}
</style>
